import { render, staticRenderFns } from "./BussinesStatusCard.vue?vue&type=template&id=a4552ca8&scoped=true&"
import script from "./bussines-status-card.ts?vue&type=script&lang=ts&"
export * from "./bussines-status-card.ts?vue&type=script&lang=ts&"
import style0 from "./bussines-status-card.scss?vue&type=style&index=0&id=a4552ca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4552ca8",
  null
  
)

export default component.exports